/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "semantic-ui-react";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice.js";
import { selectViewingOlderVersion } from "../../slices/viewingOlderVersion/viewingOlderVersionSlice.js";
import { loadNetEffectContributions, selectAllNetEffectContributions, selectNetEffectContributionsStatus, netEffectContributionDeleted } from "../../slices/netEffectContributions/netEffectContributionsSlice.js";
import jsonEquals from "../../functions/jsonEquals.js";
import ReferenceEntry from "../../datatypeComponents/ReferenceEntry.jsx";
import { fetchOutcomeVariables } from "../../slices/outcomeVariables/outcomeVariablesSlice.js";
import { selectAllResources } from "../../slices/resourceCollection/resourceCollectionSlice.js";
import { selectComparativeEvidenceMap } from "../../slices/comparativeEvidenceMap/comparativeEvidenceMapSlice.js";
import { fetchOutcomeImportance } from "../../slices/outcomreImportance/outcomeImpotanceSlice.js";

const saveChanges = async (setSaveChangesState, setChangeAvailableToSaveState, setReassignOutcomesModalState,
    dispatch, setTriggerReloadState, netEffectContributions, reassignOutcomesWorkState, resourceDictionary,
    resourceCollection, subject) => {
    let revisedNetEffectContributions = JSON.parse(JSON.stringify(netEffectContributions));
    for (const section of revisedNetEffectContributions) {
        let key = section.id;
        if (reassignOutcomesWorkState[key]) {
            let outcomeReference = reassignOutcomesWorkState[key];
            let outcomeName = outcomeReference.display.replace("OutcomeDefinition: ", "")
                .replace("VariableDefinition: ", "")
                .replace("DIO: ", "")
                .replace("DichotomousIntendedOutcome: ", "");
            section.title = outcomeName;
            section.focus = outcomeReference;
            section.section[0] = {
                "title": "Outcome",
                "code": {
                    "coding": [
                        {
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "code": "outcome-measure",
                            "display": "Outcome Measure"
                        }
                    ]
                },
                "text": {
                    "status": "generated",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + outcomeName + "</p></div>"
                },
                "entry": [outcomeReference]
            }
        }
    }
    dispatch(loadNetEffectContributions({ netEffectContributions: revisedNetEffectContributions }));

    let body = {
        findingsSection: revisedNetEffectContributions,
        combinedDictionary: resourceDictionary,
        resourceCollection: resourceCollection
    };
    dispatch(fetchOutcomeVariables(body));
    let targetResources = [];
    targetResources = revisedNetEffectContributions.map(section => {
        let targetfoi = section.focus?.reference?.replace("EvidenceVariable/", "");
        let targetfli;
        if (!targetfoi && section.focus?.identifier?.system === "https://fevir.net/FLI" && section.focus.identifier.value) {
            targetfli = section.focus.identifier.value;
        }
        let targettitle = section.focus?.display;
        return {
            id: targetfoi,
            title: targettitle,
            fli: targetfli
        };
    });
    let ratingBody = {
        targetResources: targetResources,
        subject: subject
    };
    dispatch(fetchOutcomeImportance(ratingBody));
    if (setTriggerReloadState) {
        console.log("setTriggerReloadState to true from ReassignOutcomes")
        setTriggerReloadState(true);
    }
    setSaveChangesState(false);
    setChangeAvailableToSaveState(false);
    setReassignOutcomesModalState(prevState => { return { ...prevState, modalOpen: false }; });
};

const ReassignOutcomesModal = ({ reassignOutcomesModalState, containedResourceDictionary = {},
    setReassignOutcomesModalState, setTriggerReloadState, subject }) => {

    const dispatch = useDispatch();

    const netEffectContributions = useSelector(state => selectAllNetEffectContributions(state));
    const netEffectContributionsStatus = useSelector(selectNetEffectContributionsStatus);
    const resourceCollection = useSelector(state => selectAllResources(state));

    const comparativeEvidenceMap = useSelector(selectComparativeEvidenceMap);
    const combinedDictionary = comparativeEvidenceMap.combinedDictionary;
    let resourceDictionary = JSON.parse(JSON.stringify(combinedDictionary));
    for (const entry of resourceCollection) {
        resourceDictionary[entry.id] = entry.revisedResourceJson;
    }

    const [reassignOutcomesWorkState, setReassignOutcomesWorkState] = useState({});
    const [startingOutcomesWorkState, setStartingOutcomesWorkState] = useState({});
    const [saveChangesState, setSaveChangesState] = useState(false);
    const [changeAvailableToSaveState, setChangeAvailableToSaveState] = useState(false);
    const [deleted, setDeleted] = useState([]);

    useEffect(() => {
        let outcomeReferenceDictionary = {};
        if (netEffectContributionsStatus === "succeeded") {
            for (const section of netEffectContributions) {
                outcomeReferenceDictionary[section.id] = section.focus;
            }
            setReassignOutcomesWorkState(outcomeReferenceDictionary);
            setStartingOutcomesWorkState(outcomeReferenceDictionary);
        }
    }, [netEffectContributionsStatus]);
    useEffect(() => {
        if (!jsonEquals(reassignOutcomesWorkState, startingOutcomesWorkState)) {
            setChangeAvailableToSaveState(true);
        }
    }, [reassignOutcomesWorkState])

    useEffect(() => {
        if (saveChangesState === true && netEffectContributions &&
            setTriggerReloadState) {
            saveChanges(setSaveChangesState, setChangeAvailableToSaveState, setReassignOutcomesModalState,
                dispatch, setTriggerReloadState, netEffectContributions, reassignOutcomesWorkState,
                resourceDictionary, resourceCollection, subject);
        }
    }, [saveChangesState]);

    let modalContent = <div style={{
        paddingTop: "0px", paddingLeft: "20px", paddingRight: "20px",
        paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
    }}>
        <span style={{
            position: "absolute", backgroundColor: "#FFFFFF", width: "calc(90vw - 38px)", zIndex: 100,
            paddingTop: "6px", paddingBottom: "6px"
        }} >
            <Button style={{
                color: changeAvailableToSaveState ? "#FFFFFF" : "#000000",
                width: "230px", float: "left"
            }}
                className="formButton" disabled={saveChangesState}
                content="Save Changes" positive={changeAvailableToSaveState}
                onClick={() => {
                    setSaveChangesState(true);
                }}
            />
            &nbsp;&nbsp;&nbsp;
            <Button style={{ color: "#000000", width: "180px", float: "right" }}
                className="formButton"
                content="Close Window"
                onClick={() => {
                    setReassignOutcomesModalState(prevState => { return { ...prevState, modalOpen: false }; });
                }}
            />
        </span>
        <br /><br /><br />
        <div>
            <br />
            {(reassignOutcomesWorkState) &&
                Object.keys(reassignOutcomesWorkState).map((itemNumber, itemKey) => {
                    return <div key={itemKey}>
                        {deleted.includes(itemNumber) ?
                            <span style={{ color: "#FF0000" }}><b>DELETED</b><br /></span>
                            :
                            <>
                                <h3>Set or create the structured Outcome Definition</h3>
                                <ReferenceEntry elementName={itemNumber} enableCreation={true}
                                    containedResourceDictionary={containedResourceDictionary}
                                    startCollapsed={true}
                                    fieldLabel='OutcomeDefinition (Resource Reference)'
                                    referencedResourceTypes={['EvidenceVariable']}
                                    startingResourceType="EvidenceVariable"
                                    selectProfile={["VariableDefinition", "DichotomousIntendedOutcome"]}
                                    startingValue={reassignOutcomesWorkState[itemNumber]}
                                    setResourceState={setReassignOutcomesWorkState} />
                                <Button className="formButton"
                                    negative
                                    content={`🗑️`}
                                    onClick={() => {
                                        dispatch(netEffectContributionDeleted(itemNumber));
                                        setDeleted(prevState => {
                                            return [...prevState, itemNumber]
                                        });
                                        setChangeAvailableToSaveState(true);
                                    }} />
                                <br />
                                <br />
                            </>}
                    </div>
                })
            }
        </div>
        <br /><br />
    </div>;

    return <>
        <Modal
            style={{ padding: "0px", margin: "0px" }}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            open={reassignOutcomesModalState?.modalOpen}
            centered={false}
            content={modalContent}
            className="viewmywork"
        />
    </>
}

const ReassignOutcomes = ({ setTriggerReloadState, subject, containedResourceDictionary = {} }) => {
    const apiToken = useSelector(selectCurrentUserApiToken);
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));

    const [reassignOutcomesModalState, setReassignOutcomesModalState] = useState({ "modalOpen": false });

    return <>
        {reassignOutcomesModalState &&
            <>
                {reassignOutcomesModalState.modalOpen &&
                    <ReassignOutcomesModal subject={subject}
                        reassignOutcomesModalState={reassignOutcomesModalState}
                        setReassignOutcomesModalState={setReassignOutcomesModalState}
                        containedResourceDictionary={containedResourceDictionary}
                        setTriggerReloadState={setTriggerReloadState} />
                }
                <span>
                    <Button className="formButton" style={{ color: "#000000", width: "220px" }}
                        content="Reassign Outcomes"
                        onClick={() => {
                            if (apiToken) {
                                setReassignOutcomesModalState({ "modalOpen": true });
                            } else {
                                alert("Please login to use this function.");
                            }
                        }}
                        disabled={viewingOlderVersion}
                    />
                    &nbsp;&nbsp;&nbsp;
                    <>
                        Change the assigned Resource for any of the outcomes, e.g. to use DichotomousIntendedOutcome for shared use.
                    </>
                </span>
            </>}
    </>
};

export default ReassignOutcomes;